import React from 'react';
import useCheckoutState from '../../hooks/useCheckoutState';
import { PaymentElement as StripePaymentElement } from '@stripe/react-stripe-js';
import getBillingDetailsFromFields from '../../lib/getBillingDetailsFromFields';
import getFormFieldValues from '../../lib/getFormFieldValues';

const PaymentElement = () => {
  const { setFormError, seller, selectedPaymentMethod, setSelectedPaymentMethod } =
    useCheckoutState();
  const { form } = useCheckoutState();

  const { fields } = getFormFieldValues(form.fields);
  const billingDetails = getBillingDetailsFromFields(fields);

  return (
    <div className="cp_payment-element-wrapper">
      <StripePaymentElement
        onChange={event => {
          if (event.value !== selectedPaymentMethod) {
            setFormError(null);
          }

          setSelectedPaymentMethod(event.value.type);
        }}
        options={{
          defaultValues: {
            billingDetails,
          },
          fields: {
            billingDetails: {
              email: 'never',
              ...(billingDetails.name && { name: 'never' }),
              ...(billingDetails.phone && { phone: 'never' }),
              ...(billingDetails.address && {
                address: {
                  ...(billingDetails.address.line1 && { line1: 'never' }),
                  ...(billingDetails.address.line2 && { line2: 'never' }),
                  ...(billingDetails.address.city && { city: 'never' }),
                  ...(billingDetails.address.state && { state: 'never' }),
                  ...(billingDetails.address.postal_code && {
                    postal_code: 'never',
                  }),
                  ...(billingDetails.address.country && { country: 'never' }),
                },
              }),
            },
          },

          business: {
            name: seller.displayName,
          },
        }}
      />
    </div>
  );
};

export default PaymentElement;
